export const size = {
    tablet: 768,
    desktop: 1024,
};

const device = {
    mobile: `(max-width: ${size.tablet - 1}px)`,
    tablet: `(min-width: ${size.tablet}px)`,
    desktop: `(min-width: ${size.desktop}px)`,
};

export default device;

export function isTouchDevice() {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = function(query) {
        return window.matchMedia(query).matches;
    };

    // eslint-disable-next-line no-undef
    if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const touchQuery = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(touchQuery);
}
